
import {
  email,
  required,
  minLength
} from "vuelidate/lib/validators";
import {parseUtmLabels} from "~/helpers/formSend";
import {comagicAddOfflineRequest} from "~/plugins/comagic";

export default {
  name: "Macrocabinet",

  data: function () {
    return {
      form: {
        agentFullName: "",
        agentCompanyName: "",
        agentPhone: "",
        agentEmail: "",

        clientFullName: "",
        clientPhone1: "",
        clientPhone2: "",
        clientEmail: "",

        comment: "",
      },

      isAccept: true,
      isOpenForm: false
    }
  },

  validations: function () {
    const form = {
      agentFullName: {
        required
      },
      agentPhone: {
        required,
        minLength: minLength(18)
      },
      agentEmail: {
        required,
        email
      },


      clientFullName: {
        required
      },
      clientPhone1: {
        required,
        minLength: minLength(18)
      },
    };

    return {
      form,
    };
  },

  computed: {
    errorAgentFullName: function () {
      const error = this.$v?.form?.agentFullName;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return "Обязательно к заполнению"
      }

      return null
    },
    errorAgentCompanyName: function () {
      const error = this.$v?.form?.agentCompanyName;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return "Обязательно к заполнению"
      }

      return null
    },
    errorAgentPhone: function () {
      const error = this.$v?.form?.agentPhone;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return "Обязательно к заполнению"
      }
      if (!error.minLength) {
        return "Неправильный формат ввода"
      }

      return null
    },
    errorAgentEmail: function () {
      const error = this.$v?.form?.agentEmail;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return "Обязательно к заполнению"
      }
      if (!error.email) {
        return "Неправильный формат ввода"
      }

      return null
    },

    errorClientFullName: function () {
      const error = this.$v?.form?.clientFullName;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return "Обязательно к заполнению"
      }

      return null
    },
    errorClientPhone1: function () {
      const error = this.$v?.form?.clientPhone1;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return "Обязательно к заполнению"
      }
      if (!error.minLength) {
        return "Неправильный формат ввода"
      }

      return null
    },
    errorClientPhone2: function () {
      const error = this.$v?.form?.clientPhone2;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return "Обязательно к заполнению"
      }
      if (!error.minLength) {
        return "Неправильный формат ввода"
      }

      return null
    },
    errorClientEmail: function () {
      const error = this.$v?.form?.clientEmail;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return "Обязательно к заполнению"
      }
      if (!error.email) {
        return "Неправильный формат ввода"
      }

      return null
    },
  },

  methods: {
    openForm: function () {
      this.isOpenForm = true;
    },
    closeForm: function () {
      this.isOpenForm = false;
      this.resetForm();
    },

    submitForm: async function () {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return null;
      }

      this.$store.commit("loading/setLoading", { name: 'popUpLoading', value: true });
      const message = [
        `Фио агента: ${this.form.agentFullName}`,
        `Название агентства: ${this.form.agentCompanyName}`,
        `Телефон агента: ${this.form.agentPhone}`,
        `Почта агента: ${this.form.agentEmail}`,

        `Фио клиента: ${this.form.clientFullName}`,
        `Почта клиента: ${this.form.clientEmail}`,
        `Телефон клиента: ${this.form.clientPhone1}`,
        `Дополнительный телефон клиента: ${this.form.clientPhone2}`,

        `Сообщение: ${this.form.comment || ""}`,
      ].join(";\n");
      const body = {
        type: "Форма для агента",
        name: this.form.clientFullName,
        phone: (this.form?.clientPhone1 || "").replace(/[^\d]/g, ''),
        email: this.form.clientEmail,
        url: window.location.href,
        message: message,
        additional_data: {...this.form}
      };
      const utmLabels = parseUtmLabels();
      if (utmLabels) {
        body.additional_data = {
          ...body.additional_data,
          ...utmLabels
        }
      }
      body.source = this.$cookies.get('sbjs_current') || '';
      comagicAddOfflineRequest(body);
      const response = await this.$api.agent.transport.post("/form/send", body).then((res) => {
        return res.data
      }).catch((err) => {
        return {
          error: errorParseNetwork(err.response)
        }
      });
      if (response.error) {
        this.$store.commit("loading/setLoading", { name: 'popUpLoading', value: false });

        this.$toast.error(response.error);

        return
      }

      // this.$yandexMetrika.reachGoal("ostavil_zayavku");
      this.$yandexMetrika.reachGoal("alllead");
      this.$store.commit("loading/setLoading", { name: 'popUpLoading', value: false });
      this.$toast.success("Заявка успешно отправлена");
      this.resetForm();
      this.closeForm();
    },
    resetForm: function () {
      this.form = {
        agentFullName: "",
        agentPhone: "",
        agentEmail: "",

        clientFullName: "",
        clientPhone1: "",
        clientPhone2: "",
        clientEmail: "",

        comment: "",
      };
      this.$v.$reset();
    }
  }
}
